function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.7936 44.6939C87.1919 44.6939 90.7574 41.1284 90.7574 36.7301C90.7574 32.3319 87.1919 28.7664 82.7936 28.7664C78.3953 28.7664 74.8298 32.3319 74.8298 36.7301C74.8298 41.1284 78.3953 44.6939 82.7936 44.6939Z",
  fill: "#E53170",
  stroke: "#272343",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2031 13.2468H5.04372C2.81044 13.2468 1 15.0563 1 17.2885C1 19.5206 2.81044 21.3301 5.04372 21.3301H39.2031C41.4364 21.3301 43.2468 19.5206 43.2468 17.2885C43.2468 15.0563 41.4364 13.2468 39.2031 13.2468Z",
  fill: "#F25F4C",
  stroke: "#272343",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5723 1.00024H10.6702C8.32312 1.00024 6.42041 2.90296 6.42041 5.25007C6.42041 7.59718 8.32312 9.49989 10.6702 9.49989H33.5723C35.9194 9.49989 37.8221 7.59718 37.8221 5.25007C37.8221 2.90296 35.9194 1.00024 33.5723 1.00024Z",
  fill: "#F25F4C",
  stroke: "#272343",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9621 118C52.4634 118 51.9646 118 51.4658 117.971C46.4418 117.757 41.5166 116.505 36.9998 114.294C32.4831 112.084 28.4727 108.963 25.2208 105.127C19.0161 97.786 15.6094 88.4859 15.6041 78.8739V31.8496C15.4928 24.1291 18.4895 25.0194 22.1993 24.9246C26.0246 24.8257 29.1532 24.2445 29.1532 31.6971V78.8739C29.1566 85.2812 31.4289 91.4803 35.5671 96.3719C37.6366 98.8196 40.1988 100.803 43.0868 102.194C45.9747 103.584 49.1234 104.35 52.3273 104.442C55.5313 104.533 58.7185 103.948 61.681 102.724C64.6435 101.501 67.3148 99.6663 69.5204 97.3406C73.5687 93.0302 75.8085 87.3305 75.7776 81.4172V54.8053C75.7633 53.0204 76.4432 51.2997 77.6738 50.0068C78.9045 48.7139 80.5894 47.9499 82.3729 47.8761C83.2778 47.8525 84.1783 48.0102 85.0213 48.3401C85.8643 48.67 86.6327 49.1654 87.2811 49.797C87.9296 50.4285 88.4451 51.1836 88.7971 52.0176C89.1492 52.8515 89.3307 53.7475 89.3309 54.6528V81.6439C89.3304 86.4195 88.3891 91.1483 86.5608 95.56C84.7325 99.9718 82.053 103.98 78.6753 107.356C75.2977 110.732 71.2881 113.41 66.8754 115.236C62.4628 117.063 57.7336 118.002 52.958 118H52.9621Z",
  fill: "#FF7D05",
  stroke: "#272343",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

function SvgUicoachLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 119,
    viewBox: "0 0 92 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUicoachLogo);
export default __webpack_public_path__ + "static/media/uicoach-logo.be5385a4.svg";
export { ForwardRef as ReactComponent };